import React from 'react';

type Props = {
  children: React.ReactNode;
};

export default function Label({ children }: Props) {
  return <span style={{ color: '#555555' }}>{children}</span>;
}
